import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function UserPicker({ value, onChange, label = "Person auswählen", testId = "user-picker" }) {
  const [users, setUsers] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    let active = true;
    const timer = setTimeout(() => {
      api
        .get("/users/search", { params: { q: query } })
        .then(({ data }) => active && setUsers(data || []))
        .catch(() => active && setUsers([]));
    }, 250);
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [query]);

  return (
    <div>
      <div className="eyebrow mb-2">{label}</div>
      <input
        className="field mb-2"
        placeholder="Name suchen"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        data-testid={`${testId}-search`}
      />
      <div className="max-h-48 space-y-1 overflow-auto rounded-xl border bg-white p-1">
        {users.length === 0 ? (
          <p className="p-3 text-sm text-[var(--ink-soft)]">Keine Personen gefunden.</p>
        ) : (
          users.map((u) => (
            <button
              key={u.id}
              type="button"
              onClick={() => onChange(u.id, u.display_name)}
              className={`flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm transition-colors ${
                value === u.id ? "bg-[var(--brand)] text-white" : "hover:bg-[var(--brand-soft)]"
              }`}
              data-testid={`${testId}-option-${u.display_name?.replace(/\s+/g, "-").toLowerCase()}`}
            >
              {u.display_name}
            </button>
          ))
        )}
      </div>
    </div>
  );
}

export default UserPicker;
